import { clsx } from 'clsx'
import type { ReactNode } from 'react'
import { useRef } from 'react'
import closeButtonSvg from '../../../assets/images/buttons/close-button.svg'
import { Icon } from '../../atoms'
import {
  backdrop,
  closeButtonStyle,
  headerContainer,
  headerContainerVariant,
  modalContentVariants,
  modalWrapperVariants,
  positionVariants,
  title,
} from './index.css'

export interface ModalOptionsType {
  name?: string
  title?: string
  position?: 'center' | 'left' | 'right' | 'bottom' | 'full'
  autoFocus?: boolean
  closeOnClickOutside?: boolean
  showCloseButton?: boolean
}

export const Modal = (
  props: ModalOptionsType & {
    onClose: (result?: unknown) => void
    children: ReactNode
  },
) => {
  const position = useRef(props.position || 'center')

  const onClickBackdrop: React.MouseEventHandler<HTMLDivElement> = () => {
    if (props.closeOnClickOutside) {
      props.onClose()
    }
  }

  return (
    <div
      className={clsx(backdrop, positionVariants[position.current])}
      onClick={onClickBackdrop}
    >
      <dialog
        className={modalWrapperVariants[position.current]}
        open
        autoFocus={props.autoFocus ?? true}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={clsx(
            headerContainer,
            headerContainerVariant[position.current],
          )}
        >
          {props.title ? <h1 className={title}>{props.title}</h1> : null}
          {props.showCloseButton === false ? null : (
            <Icon
              src={closeButtonSvg}
              className={closeButtonStyle}
              analytic={{
                name: 'close',
                params: props.name
                  ? {
                      modal: props.name,
                    }
                  : undefined,
              }}
              onClick={() => props.onClose()}
            />
          )}
        </div>
        <div className={modalContentVariants[position.current]}>
          {props.children}
        </div>
      </dialog>
    </div>
  )
}
